import React from "react";
import { Link } from "react-router-dom";

const LOGO_URL = "https://customer-assets-jt897jd0.emergentagent.net/job_property-hub-maxe/artifacts/j5yfwp1p_immomax%203%20%281%29.webp";

export const Logo = ({ variant = "dark", className = "" }) => {
  const onDark = variant === "light";
  return (
    <Link to="/" className={`inline-flex items-center ${className}`} data-testid="logo-link" aria-label="IMMOMAXE - Accueil">
      <img
        src={LOGO_URL}
        alt="IMMOMAXE"
        className={`w-auto object-contain ${onDark ? "h-11 sm:h-12 rounded-lg bg-white px-3 py-1.5 shadow-sm" : "h-11 sm:h-14 rounded-lg bg-white/80 px-2.5 py-1 shadow-sm"}`}
      />
    </Link>
  );
};
